import { Box, Paper, styled, Typography } from '@mui/material';

interface AddYourDocumentsCardStatusStyledTypes {
  borderColor: string;
  backgroundColor: string;
}

export const AddYourDocumentsPaperStyled = styled(Paper)(({ theme }) => ({
  boxShadow: '0px 1px 10px 0px #0000003D',
  marginBottom: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    paddingBottom: 0,
  },
}));

export const AddYourDocumentsCertificateStatusBoxStyled = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(7),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  })
);

export const AddDocumentDetailsBoxStyled = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(3),
  },
}));

export const AddYourDocumentsDependentBoxStyled = styled(Box)({
  padding: '3rem 3rem 0 3rem',
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    width: '3.2rem !important',
    height: '3.2rem !important',
  },
});

export const AddYourDocumentsCardStatusStyled = styled(
  Typography
)<AddYourDocumentsCardStatusStyledTypes>(
  ({ theme, borderColor, backgroundColor }) => ({
    background: backgroundColor,
    border: `0.5px solid ${borderColor}`,
    borderRadius: '4px',
    padding: theme.spacing(1.5),
  })
);

export const ElectedBenefitTextStyled = styled(Typography)(({ theme }) => ({
  color: theme?.palette?.grey[500],
}));

export const AddDocumentCertificateDetailsBoxStyled = styled(Box)(
  ({ theme }) => ({
    width: '45rem',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  })
);

export const DocumentRequestProfileStyled = styled(Box)({
  '& img': {
    width: '3.2rem',
    height: '3.2rem',
    borderRadius: '1.5rem',
  },
});
